import styled from "styled-components";

export const PubRestaurantWrapper = styled.div`
  padding: 20px 16px;
`;

export const PubRestaurantListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  gap: 10px;
`;

export const PubRestaurantItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  > img {
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 6px;
  }

  > .title {
    font-weight: 600;
    font-size: 16px;
  }

  > .menu {
    font-weight: 400;
    font-size: 14px;
    > span {
      font-weight: 700;
    }
  }
`;

export const PubRestaurantItemLocation = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 10px;

  > .text {
    font-weight: 400;
    font-size: 14px;
  }
`;
